import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@breakroom-nx/redux';

interface UserState {
  uid?: string;
}

const initialState: UserState = {
  uid: undefined,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    selectUser: (state, action: PayloadAction<string>) => {
      // const user: User = action.payload;
      state.uid = action.payload;
    },
    deselectUser: (state) => {
      state.uid = undefined;
    },
  },
});

export const { selectUser, deselectUser } = userSlice.actions;
export const getSelectedUser = (state: RootState) => state.user.uid;
export default userSlice.reducer;
